<template>
    <div class="view view--newsletter">
        <div class="is-flex justify-content-end align-items-center">
            <btn
                type="default"
                v-html="__('Export report')"
                v-on:click="exportData"
            />
        </div>
        <data-table
            class="has-margin-b45"
            v-bind:data="tableData"
            v-on:sort="sortDataTable"
        ></data-table>

        <delete-modal
            v-if="isOpenDeleteModal"
            v-on:close="closeDeleteModal"
            v-on:delete="deleteNewsletter"
        />
    </div>
</template>

<script>
import { Btn, Control, DataTable } from '@teamfurther/cinderblock';
import NewsletterRepository from '../../repositories/NewsletterRepository';
import NewsletterReportRepository from '../../repositories/NewsletterReportRepository';
import download from 'downloadjs';
import DeleteModal from './DeleteModal';
import store from '../../store';
import MessageHandler from '../../messageHandler';

export default {
    components: {
        DeleteModal,
        Btn,
        Control,
        DataTable
    },
    data: function() {
        return {
            deletableNewsletter: null,
            isOpenDeleteModal: false,
            newsletterRepository: new NewsletterRepository(),
            newsletterReportRepository: new NewsletterReportRepository(),
            tableData: {
                columnNames: {
                    email: this.__('Email'),
                    program: this.__('Program')
                },
                items: [],
                sortableColumns: ['email', 'program']
            }
        };
    },
    methods: {
        closeDeleteModal: function() {
            this.deletableNewsletter = null;
            this.isOpenDeleteModal = false;
        },
        deleteNewsletter: async function() {
            if (!this.deletableNewsletter) {
                return;
            }

            try {
                await this.newsletterRepository.deleteNewsletter(
                    this.deletableNewsletter.id
                );

                store.state.alerts.push(
                    new MessageHandler(
                        this.__('Newsletter was successfully deleted.'),
                        this.__('Success.'),
                        'success'
                    )
                );
            } catch (e) {
                store.state.alerts.push(
                    new MessageHandler(
                        this.__(
                            'An error occurred. Please check you connection.'
                        ),
                        this.__('Error.'),
                        'error'
                    )
                );
            } finally {
                await this.getNewsletters();
                this.isOpenDeleteModal = false;
            }
        },
        exportData: async function() {
            const data = await this.newsletterReportRepository.getNewsletterReport();

            download(data, 'newsletter-export.xls', 'application/vnd.ms-excel');
        },
        sortDataTable: function(sort) {
            this.getNewsletters(sort);
        },
        getNewsletters: async function(sort = '') {
            const newsletters = await this.newsletterRepository.getNewsletters(
                sort
            );
            const items = newsletters.map(newsletter =>
                this.transformNewsletterData(newsletter)
            );

            this.$set(this.tableData, 'items', items);
        },
        transformNewsletterData: function(newsletter) {
            let actions = [
                {
                    class: 'is-red',
                    method: 'showDeleteModal',
                    title: this.__('Delete')
                }
            ];

            return {
                values: {
                    id: newsletter.id,
                    email: newsletter.email,
                    program: newsletter.program.title
                },
                actions: actions
            };
        },
        showDeleteModal: function(newsletter) {
            this.deletableNewsletter = newsletter;
            this.isOpenDeleteModal = true;
        }
    },
    mounted: function() {
        this.getNewsletters();
    }
};
</script>
